import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=5de802a0&scoped=true&"
import script from "./Browser.vue?vue&type=script&lang=js&"
export * from "./Browser.vue?vue&type=script&lang=js&"
import style0 from "./Browser.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Browser.vue?vue&type=style&index=1&id=5de802a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de802a0",
  null
  
)

export default component.exports